import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'EMA' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'EMA', label: 'Exponential Moving Average', pane: 'main', params: [6, 12, 20], outputs: ['ema1', 'ema2', 'ema3'], labels: ['Period 1', 'Period 2', 'Period 3'] })
